import React, { useEffect, useState, useRef } from "react";
import {
  Formik,
  Form
} from "formik";
import { useNavigate } from "react-router-dom";
import {
  no_special_characters,
  mobile_number,
  alphabet_Check,
} from "../../constants/registration";
import {
  postUserLoginSignupOtp,
  getUserAuthentication,
  clearUserLoginSignupOtpResponse,
  makeOtpScreenProhibited,
  makeUserAuthenticateProhibited,
  clearLoginDataResponse,
  clearUserAuthenticationResponse,
} from "../../../store/slices/Registration/CommonSlices";
import { connect } from "react-redux";
import Cookies from "universal-cookie";
import MobileInputLogin from "../registration/RegistrationOtpVerify/mobileInputLogin"
import axios from "axios"
import { useLocation } from "react-router-dom";
import { createCurrentUrl, getAbsoluteDestinationUrl, certificationPage} from "../../utils/registrationUtils";
import DataLayerEvents from "../common/DataLayerEvents";

const CareersRegisterLogin = (props) => {
  const [formikValues, setFormikValues] = useState({});
  const navigate = useNavigate();
  const cookies = new Cookies();
  let date = new Date();
  const [formCurrentState, setFormCurrentState] = useState(null);
  const [reinitialize, setReinitialize] = useState(true)
  const [errorPopup, setErrorPopup] = useState(false)
  const destinationDomain = axios?.defaults?.env?.FormData?.REACT_APP_SUB_DOMAIN_NAME
  const { state } = useLocation();
  const loginDataCookies = cookies?.get("loginState");
  const oneClickUuid = cookies?.get("one-click-login")?.data?.uuid;
  const userUuid = oneClickUuid ? oneClickUuid : loginDataCookies?.userUuid;
  const googleUserUuid = loginDataCookies?.user_uuid;
  //to check correct current url
  const subDomainName = window.location.host?.split(".")[0];
  const urlCheck = window.location.href;
  let certificationFormCheck = window.location.search?.includes("ftype=certificationform") ||
   window.location.search?.includes("ftype=certification") || certificationPage(urlCheck);
  const currentUrl = document.referrer ? document.referrer :cookies?.get(`${subDomainName}-${certificationFormCheck}-rgData`)?.source_destination;
  const urlObj = currentUrl ? new URL(currentUrl) : null;
  const cleanUrl =urlObj ? `${urlObj.origin}${urlObj.pathname}` : null;
  const sourseDestination = cleanUrl ? `${cleanUrl}${window.location.search}` : getAbsoluteDestinationUrl();
  const urls = ["/user/login", "/user/complete-profile", "/user/register", "/user/update-profile"];
  const isMatch = urls.some(path => currentUrl?.includes(path));
//---------------------
  useEffect(() => { // to save india flag by default
    setFormCurrentState((prev) => ({ ...prev, email_field_visibility: false }))
    setTimeout(() => setReinitialize(false), 500)
    props.dispatch(makeOtpScreenProhibited());
    props.dispatch(makeUserAuthenticateProhibited());
    props.dispatch(clearLoginDataResponse());
    props.dispatch(clearUserAuthenticationResponse());
    props.dispatch(clearUserLoginSignupOtpResponse());
    const phoneNumber = cookies?.get("rgData")?.common_sign_up_mobile; // common_signup_em is added for certification old code page
    const valuesToPopulate = cookies?.get("loginState")
    // if (phoneNumber && !valuesToPopulate) {
    if(phoneNumber){
      if(!mobile_number.test(phoneNumber) && phoneNumber?.length == 10){
      mobileAuthApiCall(phoneNumber)
      }
      setFormikValues({ ...valuesToPopulate?.formValues || {}, "mobile": phoneNumber })
    } 
    if (state?.mobile) {
      setFormikValues({ ...valuesToPopulate?.formValues || {}, "mobile": state?.mobile })
      mobileAuthApiCall(state?.mobile);
    }

    // to redirect page on back button reload
    window.history.pushState(null, "", window.location.href);

  const handlePopstate = () => {
    const path = window.location.pathname; // 🔥 Actual current URL on popstate
    const isMatch = urls.some(url => path.includes(url));

    if (isMatch) {
      window.location.href = getAbsoluteDestinationUrl(); // 🔁 Redirect to safe place
    } else {
      window.location.href = path; // 🔁 Reload same page
    }

    // Push again to block further back
    window.history.pushState(null, "", window.location.href);
    };

    window.addEventListener("popstate", handlePopstate);

    return () => {
      window.removeEventListener("popstate", handlePopstate);
    };

  }, [])

  useEffect(() => {
    if (formCurrentState && !props.loginDatas?.cookies) {
      const uuidToSet = userUuid || googleUserUuid;
      const uuidKey = userUuid ? "userUuid" : "user_uuid";
      const ask_mobile_verify = loginDataCookies?.ask_mobile_verify;
      const additionalData = uuidToSet
      ? {
          [uuidKey]: uuidToSet,
          user_type: "new_user",
          ask_mobile_verify: ask_mobile_verify
        }
      : {};

      cookies.set("loginState", {
        ...formCurrentState,
        ...additionalData
      }, {
        path: "/",
        expires: new Date(date.setDate(date.getDate() + 3)),
        sameSite: "Lax",
        domain: window.location?.hostname?.includes("localhost") ? window.location?.hostname : destinationDomain,
      });
    }
  }, [formCurrentState]);
  useEffect(() => {
    const phoneNumber = cookies?.get("rgData")?.common_sign_up_mobile
    const updatedPhoneNumber = cookies?.get("loginState")?.formValues?.mobile
    if (props.usersAuthentication && phoneNumber) {
      if(phoneNumber === updatedPhoneNumber){
      otpApiCall(phoneNumber)                                                                                                                                                                                                                                                                                
      } 
      resendOtpTimer()
      setFormCurrentState((prev) => ({ ...prev, otp_timer: null }))
      cookies.set("rgData", { ...(cookies?.get("rgData") || {}), common_sign_up_mobile : null }, {
        path: "/",
        expires: new Date(date.setDate(date.getDate() + 365)),
        domain: destinationDomain,
        sameSite: "Lax",
      });
    }
  }, [props.usersAuthentication])

  useEffect(() => {
    if (props.usersLoginSignupOtp || props.usersLoginSignupOtpError?.block_user_case === "try_again") {
      navigate(
        `/user/login/otp-verify${window.location.search}`,
        {
          state: {
            mobile: formikValues?.mobile
          }
        })
    }

    if(props.userDirectToOtpScreen == false && props.usersLoginSignupOtpError?.block_user_case !== "try_again"){
      navigate(`.${window.location.search}`, { replace: true });
    }
  }, [props.usersLoginSignupOtp, props.userDirectToOtpScreen, props.usersLoginSignupOtpError])

  useEffect(() => {
    if(props.usersLoginSignupOtpError?.block_user_case === "try_again"){
      const totalRemainingSecs = props.usersLoginSignupOtpError?.available_in?.split(" ")?.[0];
      props.setRemainingSeconds(totalRemainingSecs);
      const currentTime = new Date();
      const currentSeconds = currentTime.getSeconds();
      localStorage.setItem("remainingSeconds", currentSeconds);
    }else if(props.usersLoginSignupOtp){
      resendOtpTimer();
    }
  },[props.usersLoginSignupOtpError, props.usersLoginSignupOtp])

  const validate = (values) => {
    let errors = {};

    if (!values.mobile) {
      errors.mobile = "Please enter your mobile number.";
    }
    else if (mobile_number.test(values.mobile)) {
      errors.mobile = "Mobile number should start with 6,7,8,9.";
    }
    else if (values.mobile?.length != 10) {
      errors.mobile = "Number must have 10 digits.";
    }
    else if (no_special_characters.test(values.mobile)) {
      errors.mobile = "No special character accepted.";
    }
    else if (alphabet_Check.test(values.mobile)) {
      errors.mobile = "Aplhabets are not allowed.";
    }
    setFormCurrentState((prev) => ({ ...prev, errors }))
    return errors;
  };

  const mobileAuthApiCall = (mobileNumber) => {
    let params = {};
    params.mobile_number = mobileNumber;
    props.dispatch(getUserAuthentication(params));
  }

  const otpApiCall = (mobile) => {
    let param = {};
    param.otp_on = "mobile";
    param.otp_action = "send";
    param.isd_code = "+91"
    param.mobile_number = mobile

    setFormCurrentState((prev) => ({ ...prev, sendOtpToMobile: param }))
    props.dispatch(postUserLoginSignupOtp(param));
  }

  const resendOtpTimer = () => {
    const currentTime = new Date();
    const currentSeconds = currentTime.getSeconds();
    localStorage.setItem("remainingSeconds", currentSeconds);
  };

  const updateTouchedFields = (touched) => {
    setFormCurrentState((prev) => ({ ...prev, touched }))
  }
  const onSubmit = (values) => { };

  return (
    <>
      <div>
        <Formik
          initialValues={formikValues || null}
          enableReinitialize={reinitialize}
          // validationSchema={schema}
          validate={validate}
          onSubmit={onSubmit}
        //   handleChange={handleChange}
        //   validateOnChange={true}
        //   validateOnBlur={true}
        >
          {({
            formik,
            values,
            handleChange,
            setFieldValue,
            handleBlur,
            errors,
            touched,
          }) => {

            useEffect(() => {
              setFormikValues(values);
              setFormCurrentState((prev) => ({ ...prev, formValues: values }))
              const errors = validate(values);
            }, [values]);

            const getOtpButton = () => {
              return (
                <div className="careers_register_fixed_mobile">
                  <button
                    type="submit"
                    // disabled={props.userAuthenticatedForOtp && !errors.mobile ? false : true}
                    className={props.userAuthenticatedForOtp && !errors.mobile ?
                      "careers_register_valid_button careers_register_button"
                      : "careers_register_button"}
                    disabled={(props.userAuthenticatedForOtp && !errors.mobile) ? false : true}
                    onClick={() => {
                      otpApiCall(values.mobile)
                      // setFormCurrentState((prev) => ({ ...prev, otp_timer: null }))
                      // resendOtpTimer()
                    }}
                  >
                    Get OTP
                  </button>
                  <p className="careers_register_account">
                    Don't have a Careers360 account? {" "}
                    <a href={`/user/register${window.location.search?.replace('&page=login', '')?.replace('?page=login', '')}`}>Sign Up</a> to continue
                  </p>
                </div>
              )
            }


            return (
              <>
                <DataLayerEvents contentType={"Login/Signup"} pageTypes={"login"} verticalName={props.domain?.domain}/> 
                
                <Form>
                  <MobileInputLogin
                    errors={errors}
                    handleBlur={handleBlur}
                    setFieldValue={setFieldValue}
                    touched={touched}
                    values={values}
                    updateTouchedFields={updateTouchedFields}
                    mobileAuthApiCall={mobileAuthApiCall}
                    otpApiCall={(mobile) => otpApiCall(mobile)}
                  />
                </Form>
                {getOtpButton()}
              </>
            );
          }}
        </Formik>
      </div>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    userDirectToOtpScreen: state.usersCommonData.userDirectToOtpScreen,
    userAuthenticatedForOtp: state.usersCommonData?.userAuthenticatedForOtp,
    usersAuthentication: state.usersCommonData?.userAuthentication,
    userAuthenticationErrors: state.usersCommonData?.userAuthenticationError,
    geolocationData: state.usersCommonData?.geoLocation,
    loginDatas: state.usersCommonData?.loginData,
    loginDatasLoading: state.usersCommonData?.loginDataLoading,
    loginDatasError: state.usersCommonData?.loginDataError,
    usersLoginSignupOtp: state.usersCommonData?.userLoginSignupOtp,
    usersLoginSignupOtpError: state.usersCommonData?.userLoginSignupOtpError,
    updateProfileData: state.usersCommonData?.updateProfile,
    emailDomainDatas: state.usersCommonData?.emailDomainData,
    countryCodeData: state.usersCommonData?.countryCode,
    userAuthenticationEmail: state.usersCommonData?.userAuthenticationEmail,
    userAuthenticationEmailError: state.usersCommonData?.userAuthenticationEmailError,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CareersRegisterLogin);